import { render } from "./OverviewUpload.vue?vue&type=template&id=4c7a595e"
import script from "./OverviewUpload.vue?vue&type=script&lang=js"
export * from "./OverviewUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__